import { App } from 'vue';
import { NavigationProvider } from '@/modules/navigation/providers/navigationProvider';

export const NavigationProviderPlugin = {
  install: (app: App, options: any) => {
    app.config.globalProperties.$navigationProvider = new NavigationProvider();
  },
};
